<mat-divider></mat-divider>
<footer>
    &copy; Link2Future | All Rights Reserved 2020.
</footer>